'use strict';
import _each from 'lodash/each';
import _extend from 'lodash/extend';
import _uniq from 'lodash/uniq';
import _has from 'lodash/has';
import _forIn from 'lodash/forIn';
import addWordIntoTerm from '../utils/add_word_into_term';
import { OPTIONS, STOP_WORDS } from '../utils/constant';
import getSubStrings from '../utils/get_sub_strings';
function tokenizeChinese(originText, options = {}) {
    // N-gram
    options = _extend({}, OPTIONS, options);
    let text = originText.replace(/[^\u4E00-\u9FFF\u3400-\u4DBF]+/g, '\n');
    const stopWords = _uniq(STOP_WORDS.chinese.concat(options.stopWords || []));
    const terms = {};
    const pendingTerms = {};
    _each(stopWords, (stopWord) => {
        // Not handling that stop word if it's not a Chinese word.
        // Chinese: \u4E00-\u9FFF\u3400-\u4DBF
        if (!(/^[\u4E00-\u9FFF\u3400-\u4DBF]+$/).test(stopWord)) {
            return;
        }
        text = text.replace(new RegExp(stopWord, 'g'), `${stopWord}\n`);
    });
    _each(text.split(/\n+/), (chunk) => {
        if (chunk.length <= 1) {
            return;
        }
        _each(getSubStrings(chunk, options.maxPhraseLength), (subStr) => {
            if (subStr.length <= 1) {
                return;
            }
            if (!_has(pendingTerms, subStr)) {
                pendingTerms[subStr] = 0;
            }
            pendingTerms[subStr]++;
        });
        if (options.filterSubString) {
            _forIn(pendingTerms, (count, term) => {
                _each(getSubStrings(term, options.maxPhraseLength), (subStr) => {
                    if (term === subStr) {
                        return;
                    }
                    if (_has(pendingTerms, subStr) && pendingTerms[subStr] === pendingTerms[term]) {
                        delete pendingTerms[subStr];
                    }
                });
            });
        }
    });
    _forIn(pendingTerms, (count, term) => {
        if (count >= options.minFrequency) {
            addWordIntoTerm(terms, term, term, originText);
        }
    });
    return terms;
}
export default tokenizeChinese;
//# sourceMappingURL=chinese.js.map